export const SET_GLOBAL_ALERT = 'SET_GLOBAL_ALERT';
export const HIDE_GLOBAL_ALERT = 'HIDE_GLOBAL_ALERT';
